import { ReactSelect, CustomInput } from "../kits/Inputs/Inputs";
import { useState, useEffect } from "react";
import useAxios from "../../services/useAxios";
import CustomButton from "../kits/button/CustomButton";
import ToastCustomize from "../kits/ToastCustomize";
export default function Reg({
  personnelList,
  servicesList,
  setUpdater,
  validate
}) {
  const { loading, execute: regPerformance } = useAxios("test/add_operation");

  const [personnelData, setPersonnelData] = useState({
    personnelId: "",
    serviceId: "",
    requestType: "",
    volume: ""
  });

  const [personnelDataError, setPersonnelDataError] = useState({
    personnelId: "",
    serviceId: "",
    requestType: "",
    volume: ""
  });
  const dataHandler = object => {
    setPersonnelData(prev => {
      return { ...prev, ...object };
    });
  };
  const errorHandler = object => {
    setPersonnelDataError(prev => {
      return { ...prev, ...object };
    });
  };
  const validation = () => {
    let validate = true;
    if (personnelData.personnelId == "") {
      errorHandler({ personnelId: "انتخاب کنید!" });
      validate = false;
    } else errorHandler({ personnelId: "" });
    if (personnelData.serviceId == "") {
      errorHandler({ serviceId: "انتخاب کنید!" });
      validate = false;
    } else errorHandler({ serviceId: "" });
    if (personnelData.volume == "") {
      errorHandler({ volume: "انتخاب کنید!" });
      validate = false;
    } else errorHandler({ volume: "" });
    return validate;
  };
  const submit = () => {
    let temp = {
      personnel_id: personnelData?.personnelId?.value,

      service_id: personnelData?.serviceId?.value,
      number: personnelData?.volume
    };
    regPerformance(temp).then(result => {
      console.log(result);
      if (result.status == 1) {
        ToastCustomize({
          mainText: "افزودن عملکرد با موفقیت انجام شد.",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false
        });
        setPersonnelData({
          personnelId: "",
          serviceId: "",
          requestType: "",
          volume: ""
        });
        setUpdater(prev => !prev);
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است لطفا مجدد تلاش کنید!",
          duration: 3000,
          toastType: "error",
          color: "danger",
          position: "top-center",
          hasHeader: false
        });
      }
    });
  };

  console.log(personnelData);
  return (
    <div className="py-3 px-2 d-flex align-items-center  flex-wrap reg border-bottom">
      <div className="fw-bold fs-5 pt-2"> ثبت عملکرد پرسنل</div>
      <div className="d-flex align-items-center  flex-wrap flex-grow-1 form justify-content-end">
        <div className="d-flex align-items-center per me-1">
          <label className="label pt-3">پرسنل:</label>
          <ReactSelect
            itemsList={personnelList}
            inputValue={personnelData?.personnelId}
            onChangeFunc={e => {
              dataHandler({ personnelId: e });
            }}
            id=""
            title={<div style={{ height: 10, width: "100%" }}></div>}
            inputSize="text"
            type="text"
            textErr={personnelDataError.personnelId}
            inputContainer=" flex-grow-1 select"
          />
        </div>
        {/* <div className="d-flex align-items-center sec me-1">
          <label className="label pt-3">بخش:</label>
          <ReactSelect
            // itemsList={customer}
            itemsList={servicesList}
            inputValue={""}
            onChangeFunc={(e) => {}}
            id=""
            title=""
            inputSize="lg"
            type="text"
            textErr={""}
            inputContainer=" flex-grow-1 select"
          />
        </div> */}
        <div className="d-flex align-items-center req me-1">
          <label className="label pt-3" style={{ whiteSpace: "nowrap" }}>
            نوع خدمت:
          </label>
          <ReactSelect
            itemsList={servicesList}
            inputValue={personnelData?.serviceId}
            onChangeFunc={e => {
              dataHandler({ serviceId: e });
            }}
            id=""
            title={<div style={{ height: 10, width: "100%" }}></div>}
            inputSize="text"
            type="text"
            textErr={personnelDataError.serviceId}
            inputContainer=" flex-grow-1 select"
          />
        </div>
        <div className="d-flex align-items-center pt-2 vol me-1">
          <label className="label">حجم:</label>
          <CustomInput
            id="titleTour"
            label=" "
            inputSize="text"
            type="text"
            inputContainer=" flex-grow-1 select"
            inputValue={personnelData?.volume}
            textErr={personnelDataError.volume}
            onChangeFunc={e => {
              if (!isNaN(e.target.value)) {
                dataHandler({ volume: e.target.value });
                errorHandler({ volume: "" });
              } else errorHandler({ volume: "لطفا عدد وارد کنید." });
            }}
          />
        </div>

        <div className="d-flex reg-create">
          <CustomButton
            color="success"
            size="large"
            style={{ width: 80 }}
            className="justify-content-center button ms-5 "
            state={validate == 0 ? "deactive" : "normal"}
            circle={false}
            onClick={e => {
              if (validation()) submit();
            }}
          >
            ثبت
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
